import { both } from 'ramda';

import isNumber from '../../isNumber';

// eslint-disable-next-line no-restricted-globals
var isFinitePolyfill = /*#__PURE__*/both(isNumber, isFinite);

export default isFinitePolyfill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/internal/polyfills/Number.isFinite.js
// module id = 747
// module chunks = 0